/*
 *
 *  * .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .  . .  .
 *  *    .       .       .       .       .       .       .       .       .       .       .       .
 *  *      . :SXt. .  :%X%. . ..%S%: . .    . .    .  .    .  .    .  .    .  .    .  .    .  .    .  . .
 *  *  .   .;8XSXt8 .S8@SX8@  888SS8t.    ..8  %t    .  .      .       .       .   ;X  X:      .
 *  *    . @%@:8;S8 t8%t8 X8.:88%8.X8X     ;8;:S; .       .  .   . ;;.   .  .    . t8.:X:.t..    .  . .  .
 *  *   .  8XXS tS8;X88S.SX8::8X; 8X8@ .  .:X;     . .  .   .      t@     .   .   .88    t;8   .   .
 *  *      8S88:@8@8888S X8888888.8X8@   . @ . . .  ...   .   .. . ;8  .    .   . .8S .  %8: .   .    . .
 *  *   . .8X88. ;8S%8;.  .8;:8%..8@8@   :S88.S@ ;t@::S S.  @;XttSS88;;;8;;   . %t:@8%:t X8; 8@% :; .
 *  *      8@@S  .  ...   .. .:. .8X8@ .   S;.:  X8    ;8X t8S     t8   .@;  .88; .8%. . @8.  :8 .8   . .
 *  *   . .8@@8;  .     .  .     .8X8@    .tX;  ;88.    X@ t8t     t8 .  88S t8@  :8S    @@%   t88.
 *  *      @@88:     .      .  . .8@8@  . .X .  :8: .  .@S t8@     S@.  . 88%8:.  .8S .  88:  X8%8S.  .  .
 *  *   .  8X88. .  .   . .   .  .8X8@     X : ..88t%;S@8X %8%  . .:8.     %88t  .:8S   .X8% S8S:X88:
 *  *     .8XXS    .   .         .8X8@ . ..88.    tXX SS%  :8t     @8. .  .888.   .@S .  tX: 88.. SS:  .
 *  *   .  8@88:.    .     . .  . 8X8@    .:. .    .: .  . ..  . .  .     S8%. .  .     .    ..       .  .
 *  *     .@@88:  .     .         8X8@    .     . .   .      .     .  .   SX    .   .      .      .
 *  *   .  8XX8;    .    .  .  . .8X8X .   . .      .   .  .    .       .88X. .      . . .    .  .  .  .
 *  *      ;. %  .    .       .  .;:;:.  .     .  .           .   . .  . :;      . .        .         .  .
 *  *   . . .  .   .   .  .             .   .    .   . . .  .               .  .      .  .    . .  .
 *  *        .       .      .  . .  .     .   .    .       .   . .  . .  .    .   .        .        .  .
 *  *   .  .    . .     .    .     .  .     .   .     .  .   .            .  .      . . .    .  . .     .
 *  *
 *  * Copyright FortyFix(c) 2025.
 *  * Title: DefaultCrm.ts;
 *  * Path:/Volumes/Dati/SbSW_SoftwareBySystem_Works/Fortyfix/Progetti_Angular/src/environments/BaseEnvironments/DefaultCrm.ts;
 *  * Description: ;
 *  * Author: Della Porta Giovanni Battista;
 *  * Created at: 07/11/25, 10:44;
 *  * Updated at: 07/11/25, 10:44;
 *
 */

import { Marketing } from '../Modules/Marketing';
import { Prodotti } from '../Modules/Prodotti';
import { getModule, addModule } from '../Utility/ModuleUtility';



var Environment = () => {
  var env: any = {
    baseUrl: '/marketing/database-clienti',
  };
  env = addModule(Prodotti(), env);
  env = addModule(Marketing(), env);
  env.Modules = {
    "Dashboard" : true,
    "Marketing": true,
    "Clienti": true,
    "Progetti": true,
    "Prodotti": true
  }
  env.DashboardAddon = [

    {
      url: '/anagrafica/crm/dashboard',
      initObj: [

      ],
      filters: [
        { nome: "Inizio", oggetti: ["inizio"], modificabile: true, inputType: "date", class: "col-lg-3"},
        { nome: "Fine", oggetti: ["fine"], modificabile: true, inputType: "date", class: "col-lg-3"}
      ],

      campi: [
        { nome: "Dati di Periodo", larghezza: "col-lg-12", tipo: "Intestazione", titolo : "Per Periodo"},
        { nome: "Account", tipo: "text", oggetto: "num_account_periodo", larghezza:'col-lg-2', class: 'bg-kindera' },
        { nome: "Contatti", tipo: "text", oggetto: "num_contatti_periodo", larghezza:'col-lg-2', class: 'bg-kindera' },
        { nome: "Lead", tipo: "text", oggetto: "num_lead_periodo", larghezza:'col-lg-2', class: 'bg-kindera' },
        { nome: "Ordini", tipo: "text", oggetto: "num_ordini", larghezza: 'col-lg-2', class: 'bg-kindera' },
        { nome: "Ricavi", tipo: "euro", oggetto: "num_venduto", larghezza: 'col-lg-2', class: 'bg-kindera' },

        {
          dataFunc: (x) => {
            return [
              { label: 'Account', value: x.account },
              { label: 'Precedenti', value: x.account_precedente },
            ]
          },
          nome: "Account", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Contatti', value: x.contatti },
              { label: 'Precedenti', value: x.contatti_precedente },
            ]
          },
          nome: "Contatti", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Lead', value: x.lead },
              { label: 'Precedenti', value: x.lead_precedente },
            ]
          },
          nome: "Lead", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

       

        {
          dataFunc: (x) => {
            return [
              { label: 'Acquirenti', value: x.clienti },
              { label: 'Precedenti', value: x.clienti_precedente },
            ]
          },
          nome: "Acquirenti", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'N. Ordini', value: x.ordini },
              { label: 'Precedenti', value: x.ordini_precedente },
            ]
          },
          nome: "N. Ordini", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },

        {
          dataFunc: (x) => {
            return [
              { label: 'Ricavi', value: x.venduto },
              { label: 'Precedenti', value: x.venduto_precedente },
            ]
          },
          nome: "Ricavi", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
            responsive: true,
            lineTension: 0,
            hideTutti: true,
            scales: {
              x: {
                grid: {
                  display: false,
                },
              },
              y: {
                grid: {
                  display: false,
                },
              },
            },
          }
        },



        // {
        //   dataFunc: (x) => {
        //     return [
        //       { label: 'Contatti', value: x.contatti },
        //       { label: 'Lead', value: x.lead },
        //       { label: 'Acquirenti', value: x.clienti }
        //     ]
        //   },
        //   nome: "Panoramica Generale: contatti, lead e clienti", tipo: "lineChart", class: 'bg-warning', linechartOptions: {
        //     responsive: true,
        //     lineTension: 0,
        //     hideTutti: true,
        //     scales: {
        //       x: {
        //         grid: {
        //           display: false,
        //         },
        //       },
        //       y: {
        //         grid: {
        //           display: false,
        //         },
        //       },
        //     },
        //   }
        // },

      
        {
          dataFunc: (x)=>{
            return x.clienti_fat_b2b.map(y=> {
              return {...y, ricorrenza: (parseFloat(y?.ricorrenza?.toString() ?? '0')).toFixed(1)}
            })
          },
          nome: "10 migliori clienti B2B per fatturato - ordini ",
          tipo: "table",
          oggetto: "clienti_fat_b2b",
          larghezza: 'col-lg-12',
          headers: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Ricavi', oggetti: ['fatturato'], inputType: 'text'},
            {nome: 'N. Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ],
          campi: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Fatturato', oggetti: ['fatturato'],inputType:'euro'},
            {nome: 'Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ]
        },
        {
          dataFunc: (x)=>{
              return x.clienti_fat_b2c.map(y=> {
                return {...y, ricorrenza: (parseFloat(y?.ricorrenza?.toString() ?? '0')).toFixed(1)}
              })
          },
          nome: "10 migliori clienti B2C per fatturato - ordini ",
          tipo: "table",
          oggetto: "clienti_fat_b2c",
          larghezza: 'col-lg-12',
          headers: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            { nome: 'Ricavi', oggetti: ['fatturato'], inputType: 'text'},
            {nome: 'N. Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ],
          campi: [
            {nome: 'Cliente', oggetti: ['cliente'], inputType: 'text'},
            {nome: 'Fatturato', oggetti: ['fatturato'],inputType:'euro'},
            {nome: 'Ordini', oggetti: ['ordini'], inputType: 'text'},
            {nome: 'Media riordino (gg)', oggetti: ['ricorrenza'], inputType: 'text'}
          ]
        },
        { nome: "Dati Totali", larghezza: "col-lg-12", tipo: "Intestazione", titolo: "Totali" },
        { nome: "Account", tipo: "text", oggetto: "num_account", larghezza:'col-lg-3', class: 'bg-kindera' },
        { nome: "Contatti", tipo: "text", oggetto: "num_contatti", larghezza:'col-lg-3', class: 'bg-kindera' },
        { nome: "Lead", tipo: "text", oggetto: "num_lead", larghezza:'col-lg-3', class: 'bg-kindera' },
        { nome: "Acquirenti", tipo: "text", oggetto: "num_clienti", larghezza:'col-lg-3', class: 'bg-kindera' },
        
      ]
    }
  ]
  env.ProgettiAddon = {...env.ProgettiAddon, lavorato: false};
  env.Menu = [{
    module: "Dashboard",
    path: "/dashboard/dynamic",
    title: 'menu.dashboard',
    icon: "mdi mdi-gauge",
    capacita: []
  },...env.Menu]

  return env;
};

var FullEnv = () => {
  var env: any = {};
  env = getModule(Environment());
  env.theme = 'light';
  env.style = 'FortyFix';
  env.sidebarbg = 'skin6';
  env.logoBg = 'skin6';
  env.MainColor = '#3ea26d';
  env.navbarbg = '#FFFFFF';
  env.navbarAccentColor = '#ea582a';
  env.InputLabelColor = '#333333';
  env.InputTextColor = "#4d4d4d";
  env.langSuffix = '_Crm.json';
  env.BreadcrumbType = "MenuBased";
  env.Menu.find(pl => pl?.id == 'att')?.submenu?.find(sl=> sl?.id == 'care')?.submenu.push(
    {
      id: 'C',
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=237",
      title: "- Call",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
    {
      id: 'MC', //meeting clienti
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=236",
      title: "- Meeting",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
    {
      id: 'S',
      module: "Clienti",
      path: "/task/task/edit/?type=C&tipo=238",
      title: "- Support",
      icon: "mdi mdi-account-group",
      capacita: [],
      class: ''
    },
  )
  return env;
};

export var environment: any = FullEnv();
